import { render, staticRenderFns } from "./ReviewProcessingIcon.vue?vue&type=template&id=3c4315ae&"
import script from "./ReviewProcessingIcon.vue?vue&type=script&lang=js&"
export * from "./ReviewProcessingIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports